import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';
export function useSingleSupportTicket({
  enabled = true,
  code,
}: {
  enabled?: boolean;
  code: string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: [`supportTicket/${code}`], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `supportTicket/${code}`,
      });
      return res;
    },
    enabled,
  });
}
